const GTAG_ID = 'AW-18028229435';

/** Read guest privacy settings from localStorage (set by CookieConsent) */
export function getStoredPrivacySettings() {
  try {
    const raw = localStorage.getItem('privacySettings');
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }
  return null;
}

/** True only when user accepted analytics (explicit opt-in) */
export function isAnalyticsAllowed() {
  const settings = getStoredPrivacySettings();
  if (settings && typeof settings.analyticsEnabled === 'boolean') {
    return settings.analyticsEnabled;
  }
  const consent = localStorage.getItem('cookieConsent');
  if (!consent) return false;
  return false;
}

let gtagLoaded = false;

export function injectGtag() {
  if (gtagLoaded || typeof window === 'undefined') return;
  if (document.querySelector(`script[data-gtag-id="${GTAG_ID}"]`)) {
    gtagLoaded = true;
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  window.gtag('js', new Date());
  window.gtag('config', GTAG_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  script.dataset.gtagId = GTAG_ID;
  document.head.appendChild(script);
  gtagLoaded = true;
}

export function loadAnalyticsIfConsented() {
  if (!isAnalyticsAllowed()) return;
  injectGtag();
  import('./analyticsTracker').then(({ initAnalyticsTracker }) => {
    initAnalyticsTracker();
  });
}
